module.exports = __webpack_public_path__ + "img/Hapi.44eda1c5.png";